import HomeIcon from "@mui/icons-material/Home";
import MonitorIcon from "@mui/icons-material/Monitor";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MovieIcon from "@mui/icons-material/MovieFilter";
import GameIcon from "@mui/icons-material/SportsEsports";
import ProviderIcon from "@mui/icons-material/AccountBalance";
import GenreIcon from "@mui/icons-material/MusicNote";
import Admin from "@mui/icons-material/AdminPanelSettings";
import UserIcon from "@mui/icons-material/AccountCircle";
import {
  House,
  MonitorCog,
  ChartNoAxesCombined,
  CreditCard,
  Settings,
  TableOfContents,
  Users,
  CircleDollarSign,
} from "lucide-react";

export const contentProviderMenuItems = [
  {
    label: "Dashboard",
    icon: <House />,
    isNestedRoute: false,
    route: "/",
  },

  {
    label: "Content Management",
    icon: <MonitorCog />,
    isNestedRoute: true,
    nestedItems: [
      {
        label: "Add Content",
        icon: "",
        isNestedRoute: true,
        nestedItems: [
          {
            label: "Add New Content/Agreement",
            icon: "",
            route: "/add-new-content",
          },
          {
            label: "Add Content To An Existing Cycle",
            icon: "",
            route: "/cycles",
          },
        ],
      },
      {
        label: "Agreement",
        icon: "",
        isNestedRoute: false,
        route: "/agreements",
      },
      
      {
        label: "Content Listing",
        icon: "",
        isNestedRoute: false,
        route: "/content",
      },
      {
        label: "Batch Content",
        icon: "",
        isNestedRoute: false,
        route: "/batch-content-review",
      },
      {
        label: "TV Series",
        icon: "",
        isNestedRoute: false,
        route: "/tv-series-review",
      },
      {
        label: "Albums",
        icon: "",
        isNestedRoute: false,
        route: "/albums-review",
      },
      {
        label: "Content Guidelines",
        icon: "",
        isNestedRoute: false,
        route: "/content-guidelines",
      }
    ],
  },
  {
    label: "Analytics",
    icon: <ChartNoAxesCombined />,
    isNestedRoute: false,
    route: "/analytics",
  },
  {
    label: "Payment Info",
    icon: <CreditCard />,
    isNestedRoute: true,
    nestedItems: [
      {
        label: "Payment Status",
        icon: "",
        isNestedRoute: false,
        route: "/payments",
      },
      {
        label: "Payment Details",
        icon: "",
        isNestedRoute: false,
        route: "/add-payment-details",
      },
    ],
  },
  {
    label: "Settings",
    icon: <Settings />,
    isNestedRoute: true,
    nestedItems: [
      {
        label: "User Profile",
        icon: "",
        isNestedRoute: false,
        route: "/user",
      },
      {
        label: "Terms and Conditions",
        icon: "",
        isNestedRoute: false,
        route: "/terms-conditions",
      },
      {
        label: "Security Settings",
        icon: "",
        isNestedRoute: false,
        route: "/security-settings",
      },
      {
        label: "Dashboard Configuration",
        icon: "",
        isNestedRoute: false,
        route: "/dashboard-configuration",
      },
    ],
  },
];

// const menuItems = [
//   { label: "Manifest", icon: <Admin />, route: "/", screenType: "default" },
//   {
//     label: "Dashboard",
//     icon: <DashboardIcon />,
//     route: "/",
//     screenType: "default",
//   },

//   // { label: 'Advertiser', icon: <Admin />, route: '/advertiser', screenType: 'advertiser' },
//   // {
//   //   label: "Campaign",
//   //   icon: <Admin />,
//   //   route: "/campaign",
//   //   screenType: "campaign",
//   // },
//   { label: "Campaign", icon: <Admin />, route: "/campaigns" },
//   { label: "Ad", icon: <Admin />, route: "/ads", screenType: "ads" },
//   // { label: 'Ad Detail', icon: <UserIcon />, route: '/ad/details' },

//   { label: "Advertiser", icon: <TvIcon />, route: "/advertiser" },

//   { label: "Series", icon: <TvIcon />, route: "/series" },
//   { label: "Seasons", icon: <AcUnitIcon />, route: "/seasons" },
//   { label: "Carrier", icon: <InboxIcon />, route: "/carrier" },
//   {
//     label: "Category",
//     icon: <GameIcon />,
//     route: "/category",
//     screenType: "category",
//   },
//   {
//     label: "Genre",
//     icon: <GenreIcon />,
//     route: "/genre",
//     screenType: "genre",
//   },
//   {
//     label: "Content",
//     icon: <GenreIcon />,
//     route: "/",
//     screenType: "content",
//   },
//   {
//     label: "Provider",
//     icon: <ProviderIcon />,
//     route: "/provider",
//     screenType: "provider",
//   },
//   {
//     label: "Payments",
//     icon: <ProviderIcon />,
//     route: "/payments",
//     screenType: "payment",
//   },
//   { label: "Invite User", icon: <UserIcon />, route: "/inviteUser" },
// ];

export const adminMenuItems = [
  {
    label: "Dashboard",
    icon: <House />,
    isNestedRoute: false,
    route: "/",
  },
  {
    label: "Manifest",
    icon: <Admin />,
    isNestedRoute: false,
    route: "/manifest",
  },
  // {
  //   label: "Invite User",
  //   icon: <UserIcon />,
  //   route: "/inviteUser",
  //   isNestedRoute: false,
  // },
  {
    label: "Content Review",
    icon: <TableOfContents />,
    isNestedRoute: true,
    nestedItems: [
      {
        label: "Individual Content",
        icon: "",
        isNestedRoute: false,
        route: "/content",
      },
      {
        label: "Batch Content",
        icon: "",
        isNestedRoute: false,
        route: "/batch-content-review",
      },
    ],
  },
  {
    label: "Content Providers",
    icon: <Users />,
    isNestedRoute: false,
    route: "/content-providers",
  },
  {
    label: "Payments",
    icon: <CircleDollarSign />,
    isNestedRoute: false,
    route: "/payments",
  },
  {
    label: "Settings",
    icon: <Settings />,
    isNestedRoute: true,
    nestedItems: [
      {
        label: "User Profile",
        icon: "",
        isNestedRoute: false,
        route: "/user",
      },
      {
        label: "Security Settings",
        icon: "",
        isNestedRoute: false,
        route: "/security-settings",
      },
    ],
  },
];
export const advertProviderMenuItems = [
  {
    label: "Advert Dashboard",
    icon: "advert_dashboard_icon",
    isNestedRoute: false,
    route: "/advert-provider/dashboard",
  },
  {
    label: "Create Campaign",
    icon: "create_campaign_icon",
    isNestedRoute: false,
    route: "/advert-provider/create-campaign",
  },
  {
    label: "Campaign Management",
    icon: "campaign_management_icon",
    isNestedRoute: true,
    nestedItems: [
      {
        label: "Active Campaigns",
        icon: "active_campaigns_icon",
        isNestedRoute: false,
        route: "/advert-provider/campaign-management/active",
      },
      {
        label: "Archived Campaigns",
        icon: "archived_campaigns_icon",
        isNestedRoute: false,
        route: "/advert-provider/campaign-management/archived",
      },
    ],
  },
  {
    label: "Reports",
    icon: "reports_icon",
    isNestedRoute: false,
    route: "/advert-provider/reports",
  },
];
